const image = (number) =>
  `/spa-images/saanti-${String(number).padStart(3, '0')}.webp`;

// One shared mapping keeps the public treatment pages and every POS catalogue
// view on the same SAANTI photography.
export const SERVICE_IMAGES = {
  SAANTI_THAI: image(122),
  DEEP_TISSUE: image(124),
  NECK_SHOULDER: image(121),
  AROMA_OIL: image(147),
  AROMA_COUPLE: image(108),
  HOT_STONE: image(1),
  FOOT: image(127),
  VP5: image(128),
  ADDON_HERBAL: image(126),
};

export const PRODUCT_IMAGES = {
  CRACKER: image(21),
  BALM50: image(145),
  OIL100: image(141),
  WATER: image(150),
};

export const CATALOG_FALLBACK = '/spa-images/saanti-logo-gold-transparent.png';

